// extracted by mini-css-extract-plugin
export default {"deleted":"o32dLpaala"};